export const msalConfig = {
  auth: {
    clientId: "TWÓJ_CLIENT_ID_Z_AZURE", 
    authority: "https://login.microsoftonline.com/common",
    redirectUri: "http://localhost:3000",
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};